import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import useOnboardingSx from '../../hooks/useOnboardingSx';

export default function SubdomainPreview({ url }) {
  const sx = useOnboardingSx();

  return (
    <Paper variant="outlined" sx={sx.subdomainPreviewBox}>
      <Typography variant="caption" color="text.secondary">
        Preview
      </Typography>
      <Typography variant="body2" fontWeight={500} sx={{ ...sx.accentText, wordBreak: 'break-all' }}>
        {url}
      </Typography>
    </Paper>
  );
}
